import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Params } from "@angular/router";
import { AuthUserService } from "@app/auth/services/auth-user.service";
import { AuthEffectErrors } from "@app/auth/store/effects";
import { RouterService } from "@app/root-store/router.service";
import { FirebaseDatabaseService } from "@app/shared/databases/firebase-websocket.database";
import { combineLatest, Observable, of } from "rxjs";
import { switchMap, take, tap } from "rxjs/operators";

@Component({
    selector: "app-register-page",
    templateUrl: "./register-page.component.html",
    styleUrls: ["./register-page.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterPageComponent implements OnInit {
    queryParams$: Observable<Params> = this.routerService.getQueryParams();
    inviteCodeError$: Observable<string>;

    public isUserCheckComplete = false;
    public inviteCodeError: string;

    constructor(
        private readonly routerService: RouterService,
        private readonly authUserService: AuthUserService,
        private readonly firebaseWebsocket: FirebaseDatabaseService,
        private readonly cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.checkEmailAndInviteCode();
    }

    private checkEmailAndInviteCode(): void {
        this.queryParams$
            .pipe(
                take(1),
                switchMap(queryParams => {
                    const { email, inviteCode, staff } = queryParams || {};
                    const isStaff = staff === "true";
                    if (email && inviteCode) {
                        const emailCheck$ = this.firebaseWebsocket.checkEmailExists$(email);
                        const inviteCodeCheck$ = this.authUserService.dispatchValidateInviteCode$({
                            inviteCode,
                            isStaff,
                        });

                        return combineLatest([emailCheck$, inviteCodeCheck$]).pipe(
                            take(1),
                            tap(([userExistsResponse, inviteCodeResponse]) => {
                                if (!inviteCodeResponse.isValid) {
                                    this.inviteCodeError = inviteCodeResponse.errorMessage as string;
                                    this.isUserCheckComplete = true;
                                    this.cdr.detectChanges();
                                    return;
                                }

                                if (userExistsResponse === "OK") {
                                    this.routerService.navigateToUrl([`login`], { queryParamsHandling: "merge" }, { emailExists: true });
                                    return;
                                }

                                this.isUserCheckComplete = true;
                                this.cdr.detectChanges();
                            })
                        );
                    }
                    // fall back to showing error if missing email or invite code
                    this.inviteCodeError = !isStaff ? AuthEffectErrors.invalidInviteLinkCustomer : AuthEffectErrors.invalidInviteLinkStaff;
                    this.isUserCheckComplete = true;
                    this.cdr.detectChanges();
                    return of(null);
                })
            )
            .subscribe();
    }
}
